import { render, staticRenderFns } from "./CampoDocumentoAduana.vue?vue&type=template&id=508b7791&scoped=true&"
import script from "./CampoDocumentoAduana.vue?vue&type=script&lang=js&"
export * from "./CampoDocumentoAduana.vue?vue&type=script&lang=js&"
import style0 from "./CampoDocumentoAduana.vue?vue&type=style&index=0&id=508b7791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b7791",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508b7791')) {
      api.createRecord('508b7791', component.options)
    } else {
      api.reload('508b7791', component.options)
    }
    module.hot.accept("./CampoDocumentoAduana.vue?vue&type=template&id=508b7791&scoped=true&", function () {
      api.rerender('508b7791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoDocumentoAduana.vue"
export default component.exports